/**
 * Lazy initialization module for ActiveReports
 * This ensures the license key is set before any ActiveReports functionality is used
 * and allows the library to be code-split into a separate bundle
 */

import { getConfig } from "../config";

let licenseInitialized = false;

export const initializeActiveReports = async () => {
  if (licenseInitialized) {
    return;
  }

  // Dynamically import ActiveReports Core
  const { Core } = await import("@grapecity/activereports");
  
  // Set license key if available
  const licenseKey = getConfig("REACT_APP_ACTIVE_REPORT_LICENSE_KEY");
  if (licenseKey) {
    Core.setLicenseKey(licenseKey);
  }
  
  licenseInitialized = true;
};

